export const MIN_MATCH_SCORE_TO_DISPLAY_TAG_PERC = 70;
